import {
  JSONPatchDocument,
  PagedResponse,
  QueryParams,
} from "@ofqual/portal-core/core/types";
import { AnyAction } from "redux";
import { MODULE_NAME } from "../moduleName";
import { SocItem } from "../domain/SocItem";
import { SocEvent, SocEventComplete } from "../domain/SocEvent";
import { SocMessageFilters } from "../domain/SocMessageFilters";

export interface ActionPayload<T> extends AnyAction {
  type: string;
  payload: T;
}

export const LOADED_ITEMS = `${MODULE_NAME}/LOADED_ITEMS`;
export const LOADING_ITEMS = `${MODULE_NAME}/LOADING_ITEMS`;

export const LOADED_ITEM = `${MODULE_NAME}/LOADED_ITEM`;
export const LOADING_ITEM = `${MODULE_NAME}/LOADING_ITEM`;
export const SAVED_ITEM = `${MODULE_NAME}/SAVED_ITEM`;

export const UPDATING_ITEM = `${MODULE_NAME}/UPDATING_ITEM`;
export const UPDATING_ITEM_VALIDATION_FAIL = `${MODULE_NAME}/UPDATING_ITEM_VALIDATION_FAIL`;

export const SENDING_ITEM = `${MODULE_NAME}/SENDING_ITEM`;
export const SENT_ITEM = `${MODULE_NAME}/SENT_ITEM`;

export const SEND_INTERNAL_MESSAGE = `${MODULE_NAME}/SEND_INTERNAL_MESSAGE`;

export const ASSIGN_ITEM = `${MODULE_NAME}/ASSIGN_ITEM`;
export const UNASSIGN_ITEM = `${MODULE_NAME}/UNASSIGN_ITEM`;

export const ADD_CASE_NOTE = `${MODULE_NAME}/ADD_CASE_NOTE`;

export const CLOSE_ITEM = `${MODULE_NAME}/CLOSE_ITEM`;
export const CLOSED_ITEM = `${MODULE_NAME}/CLOSED_ITEM`;

export const REOPEN_ITEM = `${MODULE_NAME}/REOPEN_ITEM`;

export const SENDING_MESSAGE = `${MODULE_NAME}/SENDING_MESSAGE`;
export const SENDING_MULTIPLE_MESSAGE = `${MODULE_NAME}/SENDING_MULTIPLE_MESSAGE`;
export const SENT_MULTIPLE_MESSAGE = `${MODULE_NAME}/SENT_MULTIPLE_MESSAGE`;
export const RESET_MULTIPLE_MESSAGE = `${MODULE_NAME}/RESET_MULTIPLE_MESSAGE`;

export const ADD_EVENT = `${MODULE_NAME}/ADD_EVENT`;
export const COMPLETE_EVENT = `${MODULE_NAME}/COMPLETE_EVENT`;

export const RESUBMIT_ITEM = `${MODULE_NAME}/RESUBMIT_ITEM`;

export const loadedItems = (payload: PagedResponse<SocItem>) => ({
  type: LOADED_ITEMS,
  payload,
});
export const loadingItems = (payload: QueryParams) => ({
  type: LOADING_ITEMS,
  payload,
});

export const loadedItem = (item: SocItem) => ({
  type: LOADED_ITEM,
  payload: item,
});

export const savedItem = (item: SocItem) => ({
  type: SAVED_ITEM,
  payload: item,
});

export const loadingItem = (id: string) => ({
  type: LOADING_ITEM,
  payload: id,
});

export const updatingItem = (id: string, patchDocument: JSONPatchDocument) => ({
  type: UPDATING_ITEM,
  payload: { id, patchDocument },
});

export const sendingItem = (id: string, patchDocument: JSONPatchDocument, shareUpn: string) => ({
  type: SENDING_ITEM,
  payload: { id, patchDocument, shareUpn },
});

export const sentItem = (item: SocItem) => ({
  type: SENT_ITEM,
  payload: item,
});

export const sendInternalMessage = (
  id: string,
  files: File[],
  subject: string,
  message: string,
  recipients: string[]
) => ({
  type: SEND_INTERNAL_MESSAGE,
  payload: { id, files, subject, message, recipients },
});

export const assignCase = (id: string, upn: string, displayName: string) => ({
  type: ASSIGN_ITEM,
  payload: { id, upn, displayName },
});

export const unassignCase = (id: string) => ({
  type: UNASSIGN_ITEM,
  payload: { id },
});

export const addCaseNote = (
  id: string,
  files: File[],
  note: string,
  noteType: number
) => ({
  type: ADD_CASE_NOTE,
  payload: { id, files, note, noteType },
});

export const closeSoc = (id: string, patchDocument: JSONPatchDocument) => ({
  type: CLOSE_ITEM,
  payload: { id, patchDocument },
});

export const closedSoc = (item: SocItem) => ({
  type: CLOSED_ITEM,
  payload: item,
});

export const reopenSoc = (id: string) => ({
  type: REOPEN_ITEM,
  payload: { id },
});

export const sendMessage = (id: string, files: File[], message: string) => ({
  type: SENDING_MESSAGE,
  payload: { id, files, message },
});

export const sendMultipleMessage = (files: File[], message: string, filters: SocMessageFilters) => ({
  type: SENDING_MULTIPLE_MESSAGE,
  payload: { files, message, filters },
});

export const sentMultipleMessage = (payload: number) => ({
  type: SENT_MULTIPLE_MESSAGE,
  payload
});

export const resetMultipleMessage = () => ({
  type: RESET_MULTIPLE_MESSAGE,
});


export const addEvent = (
  id: string,
  newEvent: SocEvent
) => ({
  type: ADD_EVENT,
  payload: { id, newEvent },
});

export const completeEvent = (
  id: string,
  eventId: string,
  completedEvent: SocEventComplete
) => ({
  type: COMPLETE_EVENT,
  payload: { id, eventId, completedEvent },
});

export const enableResubmission = (id: string) => ({
  type: RESUBMIT_ITEM,
  payload: { id },
});
